<template>
	<component :is="component" :data="data" :moduleId="moduleId" />
</template>

<script setup>
import MobOverviewStandard from '@rebuild/materials/shared/widget_shell/MobOverview.vue';
import MobOverviewInSH600519 from './SH600519_mob_overview.vue';
import { contentData } from './content';
import { computed } from 'vue';

const props = defineProps({
	data: {
		type: String,
		default: ''
	},
	moduleId: {
		type: String,
		default: ''
	}
});

const component = computed(() => {
	return contentData.displayModuleIds.includes(props.moduleId) ? MobOverviewInSH600519 : MobOverviewStandard;
});
</script>
